<template>
	<div class="pubpayment">
		<header-view :tabsign='1'></header-view>
		
		<el-dialog title="支付二维码" :visible.sync="openOff" center 
		:append-to-body='true' :lock-scroll="false" width="30%">
		     <div style="display: flex;justify-content: center;">
				<img class="" :src="qrCodePath" 
				alt="" style="height: 2rem;width: 2rem;"/> 
			 </div>
		    
		</el-dialog>
		
		<el-dialog title="捐赠证书" :visible.sync="openOffZS" center
		:append-to-body='true' :lock-scroll="false" width="50%">
		     <div style="display: flex;justify-content: center;">
				<img class="" id="myimg" :src="imgUrlZS" 
				alt="" style="width: 100%;height: 100%;"/> 
			 </div>
			 
		     <div style="display:flex;justify-content: center;">
				<div style="width:0.8rem;height: 0.6rem;line-height:0.6rem;
				text-align:center;background: #E50112;cursor: pointer;margin-top: 0.2rem;
				border: 1px solid #E60012;font-size: 0.18rem;color: #FFFFFF;"
				@click="downLoad">
					下载</div> 
			 </div>
		</el-dialog>
		
		<div class="con_tent">		
			<div class="concar">
				<div class="toptitle">
					<div class="left_c">
						<div class="redcon"></div>
						<span>公益项目</span>
					</div>
					<div class="right_c">
						
					</div>
				</div>
				
				<div class="tabcon">
					<div :class="tabsign == 1?'donate_cur':'donate'" @click="changetab(1)">个人捐助</div>
					<div :class="tabsign == 2?'donate_cur':'donate'" @click="changetab(2)">单位捐助</div>
				</div>
				
				<div class="company_info" v-if="tabsign == 2">
					<div class="infocon">
						<div class="imgcar">
							<img class="" src="../../assets/newimg/favicon.png" alt="" />
						</div>
						<div class="line"></div>
						<div class="concent">
							<div class="title">户名：青海省青少年发展基金会</div>
							<div class="title">纳税人识别号：53630000521836639H</div>
							<div class="title">地址：青海省西宁市城中区北大街3号</div>
							<div class="title">捐助热线：0971-8232020</div>	
							<div class="title">开户行：建行北大街支行</div>
							<div class="title">账户：63001513737050016616</div>
						</div>
					</div>
				</div>
				
				<div class="p_donate">
					<div class="p_con">
						<div class="img_text">
							<img class="" src="../../assets/newimg/donateprice@2x.png" alt="" />
							<span>捐助金额</span>
						</div>
						
						<div class="peopleprice">
							<div class="people">
								<span>捐助人：</span>
								<el-input style="width: 2rem" v-model="name" placeholder="请输入捐助人" @change="usernameFn"></el-input>
							</div>
							<div class="price">
								<span>金额：</span>
								<el-input style="width: 2.4rem" @input="formatValue(amount)"
								v-model="amount" placeholder="请输入金额"></el-input>
							</div>
						</div>
						
						<div class="line"></div>
						
						<div class="img_text" v-if="tabsign == 1">
							<img class="" src="../../assets/newimg/donatemode@2x.png" alt="" />
							<span>确认支付方式</span>
						</div>
						
						<div class="modecon" v-if="tabsign == 1">
							<div class="list_a">
								<div class="title">手机支付：</div>								
								<div class="chioceinfo">
									<div class="wx_zfb" @click="changemode(1)">
										<div :class="modesign == 1?'yq_cur':'yq'"></div>
										<img class="img" src="../../assets/newimg/jz_weChat_img.png"/>
										<div class="bg">
											微信支付
										</div>
										<div class="ms">推荐使用：用微信扫一扫就能支付</div>
									</div>
									<div class="wx_zfb" @click="changemode(2)">
										<div :class="modesign == 2?'yq_cur':'yq'" ></div>
										<img class="img" src="../../assets/newimg/jz_alipay_img.png"/>
										<div class="bg">
											支付宝支付
										</div>
										<div class="ms">全球领先独立第三方支付平台，致力于为广大用户提供安全快速的电子支付方式</div>
									</div>
								</div>
							</div>
							
							<div class="list_a">
								<div class="title">网银支付：</div>
								<div class="chioceinfo">
									<div class="wx_zfb" @click="changemode(3)">
										<div :class="modesign == 3?'yq_cur':'yq'"></div>
										<img class="img" src="../../assets/newimg/jz_unionPay_img.png"/>
										<div class="bg">
											网银支付
										</div>
										<div class="ms">网银支付，支持以下银行卡扫码支付</div>
									</div>
								</div>
							</div>
							
						</div>
						
						<div class="line" v-if="tabsign == 1"></div>
						
						<div class="pricecon">
							<div class="l_c">
								<span class="a">应付金额：</span>
								<span class="b">￥</span>
								<span class="c" v-if="isNaN(parseFloat(amount).toFixed(2))">0.00</span>
								<span class="c" v-if="!isNaN(parseFloat(amount).toFixed(2))">{{parseFloat(amount).toFixed(2)}}</span>
							</div>
							<!-- <div class="r_c">
								<div :class="ifinvoice?'circle_cur':'circle'" @click="changeinvoice"></div>
								<span @click="changeinvoice">开具发票</span>
							</div> -->
						</div>
						
						<div class="img_text" v-if="ifinvoice">
							<img class="" src="../../assets/newimg/donateinvoice@2x.png" alt="" />
							<span>发票信息</span>
						</div>	
						
						<div class="inform_con">
							<div class="s_choice" v-if="ifinvoice">
								<div class="name">*抬头类型：</div>
								<div class="radiocon">
									<div :class="typesign == 1?'circle_cur':'circle'" @click="changetype(1)"></div>
									<div class="title" @click="changetype(1)">个人</div>
									<div :class="typesign == 2?'circle_cur':'circle'" @click="changetype(2)"></div>
									<div class="title" @click="changetype(2)">单位</div>
								</div>
							</div>
							<div class="l_a" v-if="ifinvoice">
								<div class="name" v-if="typesign == 1">*姓名：</div>
								<div class="name" v-if="typesign == 2">*公司名称：</div>
								<el-input style="width: 2.4rem;margin-right: 0.4rem;" v-model="username" :placeholder="typesign == 1?'请输入姓名':'请输入公司名称'" @change="usernameFn"></el-input>
								<div class="name" v-if="typesign == 2">*公司税号：</div>
								<el-input v-if="typesign == 2" style="width: 2.4rem" v-model="paragraph" placeholder="请输入公司税号"></el-input>
							</div>
							<div class="l_a" v-if="ifinvoice && typesign == 2">
								<div class="name">*开户银行：</div>
								<el-input style="width: 2.4rem;margin-right: 0.4rem;" v-model="bank" placeholder="请输入开户银行"></el-input>
								<div class="name">*开户行账号：</div>
								<el-input style="width: 2.4rem" v-model="account" placeholder="请输入开户行账号"></el-input>
							</div>
							<div class="l_a" v-if="ifinvoice">
								<div class="name">*收件人：</div>
								<el-input style="width: 2.4rem;margin-right: 0.4rem;" v-model="addressee" placeholder="请输入收件人姓名"></el-input>
								<div class="name">*手机号码：</div>
								<el-input style="width: 2.4rem" v-model="phone" placeholder="请输入收件人手机号码"></el-input>
							</div>
							
							<div class="l_a" v-if="ifinvoice">
								<div class="name">*收件人地址：</div>
								<el-input style="width: 6.38rem;margin-right: 0.4rem;" v-model="address" placeholder="请输入收件人地址"></el-input>
							</div>
							
							<div class="btncon">
								<div class="nextstep" v-if="tabsign == 1" @click="nextstep">下一步 > </div>
								<div class="nextstep" v-if="tabsign == 2" @click="submitbtn">提交</div>
							</div>
						</div>					
						
					</div>
					
				</div>
					
			</div>	
		
		</div>
			

			
	</div>
	
</template>

<script>

import { MessageBox } from 'element-ui';
export default {
	
  data: function() {
		return {
			isPhoneTip:false,
			activityId:"",
			activityname:"",
			openOff:false,
			qrCodePath:"",
			
			ifinvoice:false,
		    tabsign:1,
			modesign:0,
			typesign:1,
			input1:"",
			name:"",
			amount:"",
			username:"",
			paragraph:"",
			bank:"",
			account:"",
			addressee:"",
			phone:"",
			address:"",
			
			openOffZS:false,
			imgUrlZS:'',
			timer:null,
			
			oldUsername:'',
			isAddTip:true,
			addSuccess:false,

			isEnterprise:false,//企业
		};
  },
  
  mounted() {
	this.isPhoneTip=this.isPhone();
	console.log('isPhoneTip',this.isPhoneTip)
	if(this.tabsign == 1){ 
		this.isEnterprise=false;
	}
	if(this.tabsign == 2){ 
		this.isEnterprise=true
	}

	 this.imgUrlZS = require('../../assets/newimg/donatecertificate.png')
  	 this.activityId = this.$route.query.id;	
	 this.activityname = this.$route.query.title;
	
	 window.pageYOffset = 0;
	 document.documentElement.scrollTop = 0;
	 document.body.scrollTop = 0;
	
	if(this.isIosFn()){
		//针对safari不想留住缓存的情况，渴望刷新，新增解决方案：监听页面的pageshow事件
		window.addEventListener('pageshow', function (event) {
			if (event.persisted || window.performance &&
					window.performance.navigation.type == 2)
			{
				location.reload();
			}
		},false);
	}
  },
  
  updated() {
		
  },
  
  destroyed() {
     clearInterval(this.timer);
  },
  
  methods: {
	isIosFn(){
		let u = navigator.userAgent
		return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)//!!u.match(matcher:/\(i[^;]+;(U;)?CPU.+Mac OS X/) //ios终端
	},
	isPhone(){
		let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
		return flag;
	},
	 //生成水印文字 canvas文字你可以设置为你喜欢的样式
	conformText() {
		 // 创建所需要添加水印的img图片
	    var img = new Image()
	    img.src = require('../../assets/newimg/donatecertificate.png')
		img.crossOrigin = 'anonymous'
		setTimeout(() =>{
			var canvas = document.createElement('canvas') //准备空画布
			canvas.width = img.width
			canvas.height = img.height
			var ctx = canvas.getContext("2d")
			ctx.drawImage(img, 0, 0)
			// ctx.drawImage(img, 0, 0,350, 200);
		
			ctx.font = "30px Georgia" //canvas字体
			ctx.fillText(this.name, 160, 370)
			ctx.fillText(this.activityname, 480, 460)
			ctx.fillText(this.amount, 160, 520)
			var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0)
			gradient.addColorStop("0", "magenta")
			gradient.addColorStop("0.5", "blue")
			gradient.addColorStop("1.0", "red")
			ctx.fillStyle = gradient
			this.imgUrlZS = canvas.toDataURL()
			console.log(this.imgUrlZS)
			
			this.openOffZS = true;
		
		},1000);
		
	},
	
	//下载捐赠证书
	downLoad() {
		var a = document.createElement('a');
		a.href = this.imgUrlZS;  //将画布内的信息导出为png图片数据
		a.download = '捐赠证书';  //设定下载名称 如果不设置a.download 浏览器会尝试打开这张图片 而图片会下载失败
		a.click(); //点击触发下载
	},
		  
	changeinvoice(){
		this.ifinvoice = !this.ifinvoice
	},
	
	changetab(sign){
		this.tabsign = sign
		window.pageYOffset = 0;
		document.documentElement.scrollTop = 0;
		document.body.scrollTop = 0; 
		this.isEnterprise=sign==1?false:true
	},
		  	  
	changemode(sign){
		this.modesign = sign
	},
	
	changetype(sign){	
		this.typesign = sign
	},
	
	// 只允许输入金额类型，最大两位小数（如：3.88）
	formatValue(val){
		val = val.replace(/(^\s*)|(\s*$)/g, "");
		if (!val) return this.amount = "";
		val = val.replace(/[^\d.]/g, "");
		val = val.replace(/^\./g, "");
		val = val
			.replace(".", "$#$")
			.replace(/\./g, "")
			.replace("$#$", ".");
		val = val.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
		this.amount = val;
	},
	
	//下一步
	nextstep(){
		if(this.modesign != 3){
			if(this.name == ''){
				this.$alert('捐助人不能为空', '提示', {
					  confirmButtonText: '确定',
					  callback: action => {}
				});
				return
			}
			if(this.amount == ''){
				this.$alert('金额不能为空', '提示', {
					  confirmButtonText: '确定',
					  callback: action => {}
				});
				return
			}
		}		
		
		if(this.modesign == 0){
			this.$alert('请选择支付方式', '提示', {
				  confirmButtonText: '确定',
				  callback: action => {}
			});
			return
		}
		
		if(this.ifinvoice){
			if(this.typesign == 1){
				if(this.username == ''){
					this.$alert('姓名不能为空', '提示', {
						  confirmButtonText: '确定',
						  callback: action => {}
					});
					return
				}
				if(this.addressee == ''){
					this.$alert('收件人不能为空', '提示', {
						  confirmButtonText: '确定',
						  callback: action => {}
					});
					return
				}
				if(this.phone == ''){
					this.$alert('手机号码不能为空', '提示', {
						  confirmButtonText: '确定',
						  callback: action => {}
					});
					return
				}
				if(this.address == ''){
					this.$alert('收件人地址不能为空', '提示', {
						  confirmButtonText: '确定',
						  callback: action => {}
					});
					return
				}
				
			}else if(this.typesign == 2){
				if(this.username == ''){
					this.$alert('公司姓名不能为空', '提示', {
						  confirmButtonText: '确定',
						  callback: action => {}
					});
					return
				}
				if(this.paragraph == ''){
					this.$alert('公司税号不能为空', '提示', {
						  confirmButtonText: '确定',
						  callback: action => {}
					});
					return
				}
				if(this.bank == ''){
					this.$alert('开户银行不能为空', '提示', {
						  confirmButtonText: '确定',
						  callback: action => {}
					});
					return
				}
				if(this.account == ''){
					this.$alert('开户行账号不能为空', '提示', {
						  confirmButtonText: '确定',
						  callback: action => {}
					});
					return
				}
				
				if(this.addressee == ''){
					this.$alert('收件人不能为空', '提示', {
						  confirmButtonText: '确定',
						  callback: action => {}
					});
					return
				}
				if(this.phone == ''){
					this.$alert('手机号码不能为空', '提示', {
						  confirmButtonText: '确定',
						  callback: action => {}
					});
					return
				}
				if(this.address == ''){
					this.$alert('收件人地址不能为空', '提示', {
						  confirmButtonText: '确定',
						  callback: action => {}
					});
					return
				}
							
			}
		
		}		
		
		this.getQR()
	},
	getQR(){
		if(this.modesign == 1){//微信支付
			// this.$message.warning("暂未开放")
			console.log('111')
			this.getPaymentChart(1)
		}else if(this.modesign == 2){//支付宝
			this.getPaymentChart(2);
		}else if(this.modesign == 3){
			this.getPayCodeUrl();
		}
		// this.peopleDonate();
	},
	peopleDonate(){
		var self = this;
		var invoiceType = "0"
		if(this.typesign == 1){
			invoiceType = "0"
		}else{
			invoiceType = "1"
		}
		this.httpPost("web/unionPay/add", {
			  activityId: this.activityId,
			  donationUserId:this.name,
			  money:this.amount,
			  contributionType:'0',
			  invoice:this.ifinvoice?'0':'1',	
			  invoiceType:invoiceType,
			  companyName: this.username,
			  companyTax: this.paragraph,
			  bank: this.bank,
			  account: this.account,
			  addressee: this.addressee,
			  phone: this.phone,
			  address: this.address,
		}).then(res => {
			if(res.success){
				// this.$alert('提交成功', '提示', {
				// 	  confirmButtonText: '确定',
				// 	  callback: action => {}
				// });	
			}			
		});	
		
	},
	
	submitbtn(){
		if(this.name == ''){
			this.$alert('捐助人不能为空', '提示', {
				  confirmButtonText: '确定',
				  callback: action => {}
			});
			return
		}
		if(this.amount == ''){
			this.$alert('金额不能为空', '提示', {
				  confirmButtonText: '确定',
				  callback: action => {}
			});
			return
		}
		
		if(this.ifinvoice){
			if(this.typesign == 1){
				if(this.username == ''){
					this.$alert('姓名不能为空', '提示', {
						  confirmButtonText: '确定',
						  callback: action => {}
					});
					return
				}
				if(this.addressee == ''){
					this.$alert('收件人不能为空', '提示', {
						  confirmButtonText: '确定',
						  callback: action => {}
					});
					return
				}
				if(this.phone == ''){
					this.$alert('手机号码不能为空', '提示', {
						  confirmButtonText: '确定',
						  callback: action => {}
					});
					return
				}
				if(this.address == ''){
					this.$alert('收件人地址不能为空', '提示', {
						  confirmButtonText: '确定',
						  callback: action => {}
					});
					return
				}
				
			}else if(this.typesign == 2){
				if(this.username == ''){
					this.$alert('公司姓名不能为空', '提示', {
						  confirmButtonText: '确定',
						  callback: action => {}
					});
					return
				}
				if(this.paragraph == ''){
					this.$alert('公司税号不能为空', '提示', {
						  confirmButtonText: '确定',
						  callback: action => {}
					});
					return
				}
				if(this.bank == ''){
					this.$alert('开户银行不能为空', '提示', {
						  confirmButtonText: '确定',
						  callback: action => {}
					});
					return
				}
				if(this.account == ''){
					this.$alert('开户行账号不能为空', '提示', {
						  confirmButtonText: '确定',
						  callback: action => {}
					});
					return
				}
				
				if(this.addressee == ''){
					this.$alert('收件人不能为空', '提示', {
						  confirmButtonText: '确定',
						  callback: action => {}
					});
					return
				}
				if(this.phone == ''){
					this.$alert('手机号码不能为空', '提示', {
						  confirmButtonText: '确定',
						  callback: action => {}
					});
					return
				}
				if(this.address == ''){
					this.$alert('收件人地址不能为空', '提示', {
						  confirmButtonText: '确定',
						  callback: action => {}
					});
					return
				}
							
			}

		}
		
		this.enterpriseDonate();
		// this.conformText();
			
	},
	usernameFn(e){
		console.log(12,e)
		this.isAddTip=true
	},
	enterpriseDonate(){
		var self = this;
		var invoiceType = "0"
		if(this.typesign == 1){
			invoiceType = "0"
		}else{
			invoiceType = "1"
		}
		
		if(!this.isAddTip){
			this.$alert('已提交，请勿重复提交', '提示', {
				confirmButtonText: '确定',
				callback: action => {}
			});
			return
		}
		if(this.addSuccess){ 
			var that=this;
			MessageBox.confirm('是否重新捐款？', '已捐款', {
				distinguishCancelAndClose: true,
				confirmButtonText: '确认',
				cancelButtonText: '取消'
			}).then(() => {
				// that.$message.success('确认');
				that.addFn(invoiceType)
				console.log('确认')
			}).catch(action => {
				console.log('取消')
				return
			});
		}else{ 
			this.addFn(invoiceType)
			console.log('提交1')
		}
	},
	addFn(invoiceType){
		this.oldUsername=this.username;
		this.isAddTip=false;

		this.httpPost("web/unionPay/add", {
			  activityId: this.activityId,
			  donationUserId:this.name,
			  money:this.amount,
			  contributionType:'1',
			  invoice:this.ifinvoice?'0':'1',			  
			  invoiceType:invoiceType,
			  companyName: this.username,
			  companyTax: this.paragraph,
			  bank: this.bank,
			  account: this.account,
			  addressee: this.addressee,
			  phone: this.phone,
			  address: this.address,
		}).then(res => {
			this.isAddTip=true;
			if(res.success){
				this.addSuccess=true;
				// this.$alert('提交成功', '提示', {
				// 	  confirmButtonText: '确定',
				// 	  callback: action => {}
				// });	
				this.open()
			}			
		});	
	},
	//生成支付宝二维码
	getPaymentChart(type){//type 1微信2支付宝
		var self = this;
		var invoiceType = "0"
		if(this.typesign == 1){
			invoiceType = "0"
		}else{
			invoiceType = "1"
		}
		var param = {
			activityId: this.activityId,
			donationUserId: this.name,
			money:this.amount// parseInt(this.amount)//取整
		}
		if(this.ifinvoice){
			param.invoice = '0'
			param.contributionType = '1'
			if(this.typesign == 1){
				param.invoiceType = '0'
				param.companyName = this.username
				param.addressee = this.addressee
				param.phone = this.phone
				param.address = this.address
			}else if(this.typesign == 2){
				param.invoiceType = '1'
				param.companyName = this.username
				param.companyTax = this.paragraph
				param.bank = this.bank
				param.account = this.account
				param.addressee = this.addressee
				param.phone = this.phone
				param.address = this.address
			}
		
		}
		var url=''
		if(this.isPhoneTip){//手机
			url=type==1?"web/unionPay/wxPayH5":"web/unionPay/aliH5Pay"
		}else{//pc
			url=type==1?"web/unionPay/wxPayCode":"web/unionPay/alipayQrcode"
		}

		this.httpPost(url, param).then(res => {
			// replace(/\s/g, "").replace(/[\r\n]/g,""); // 去掉所有空格和换行符
			if(this.isPhoneTip){ //手机 
				console.log('手机-res',res)
				if(type==1){ //微信
					if(res.result.payUrl){ 
						this.isIosFn()?window.location.href=(res.result.payUrl):window.open(res.result.payUrl);
						this.orderFn(res)
					}
				}else{ //支付宝
					// let routerData = this.$router.resolve({path:'/payGateWay',query:{ htmlData: res.result.formData}})
					// // 打开新页面
					// window.open(routerData.href, '_ blank')
					// var type=this.getType()
					// this.$router.push({
					// 	path:'/payGateWay',
					// 	query:{ 
					// 		htmlData: res.result.formData,
					// 		orderId:res.result.orderId,
					// 		type:type
					// 	}
					// });

					const div = document.createElement('div');
					div.innerHTML = (res.result.formData);  //res.data是返回的表单
					document.body.appendChild(div);
					console.log('document',document)
					document.forms['punchout_form'].submit();
					this.orderFn(res)
				}
				
			}else{  //pc
				this.qrCodePath = res.result.qrCodePath;
				if(this.qrCodePath){ 
					this.$message.warning(res.result.message)
				}
				this.openOff = true	
				this.orderFn(res)
			}
					
						
		});			
	},
	getType(){
		var type=this.isEnterprise==false?1:0;
		if(this.isEnterprise==false&&this.modesign==3){ 
			type=0
		}
		return type
	},
	orderFn(res){
		var self = this;
		if(res.result.orderId != undefined){
			//启用定时器
			clearInterval(this.timer);
			this.timer = setInterval(function(){
				self.ifPaySuccess(res.result.orderId);
			},5000);
		}	
	},
	//是否支付成功
	ifPaySuccess(orderId){
		this.httpGet("web/unionPay/aliget", {
			  orderId: orderId,
		}).then(res => {
			if(res.result.type == "1"){
				clearInterval(this.timer);
				console.log(res, "支付成功");
				this.openOff = false	
				this.open(orderId);
			}
		});
	},
	
	//提示
	open(orderId) {
		this.$message.success('支付成功')
		// var type=this.isEnterprise==false?1:0;
		// if(this.isEnterprise==false&&this.modesign==3){ 
		// 	type=0
		// }
		var type=this.getType()
		this.$router.push({ path: "/paymentSuccess",query:{id:orderId?orderId:this.activityId,type:type}});
		// this.conformText();
	},
	
	//生成银行二维码
	getPayCodeUrl(){
		var self = this;
		this.httpGet("web/unionPay/getCodeUrl", {}).then(res => {
			this.qrCodePath = this.getFileAccessHttpUrl(res.result.value);
			this.openOff = true	
			// this.open();	
					
		});	
		
	},
	  	  
  },
 
  
};
</script>

<style scoped=" scoped" lang="scss">
	
.pubpayment{
	.con_tent{
		display: flex;
		justify-content: center;
	}
	.concar {
		width: 12rem;
		min-height: 950px;
		background: #ffffff;
		margin-top: 1rem;
	    // overflow: auto;
		.toptitle{
			height: 0.6rem;
			border-bottom: 1px solid #ededed;
			display: flex;
			align-items: center;
			justify-content: space-between;
			.left_c{
				display: flex;
				align-items: center;
				.redcon{
					width: 0.05rem;
					height: 0.2rem;
					background: #E70012;
					margin-right: 0.2rem;
				}
				font-size: 0.25rem;
				font-weight: 400;
				color: #E61F26;
			}
			.right_c{
				
			}
		}
		
		.tabcon{
			height: 0.8rem;
			display: flex;
			align-items: flex-end;
			justify-content: center;
			border-bottom: 1px solid #E50112;
			.donate_cur{
				cursor: pointer;
				width: 1.99rem;
				height: 0.4rem;
				line-height: 0.4rem;
				text-align: center;
				background: #E50112;
				border-radius: 0.05rem;
				font-size: 0.16rem;
				font-weight: 400;
				color: #FFFFFF;
			}
			.donate{
				cursor: pointer;
				width: 1.99rem;
				height: 0.4rem;
				line-height: 0.4rem;
				text-align: center;
				background: #EEEEEE;
				border-radius: 0.05rem;
				font-size: 0.16rem;
				font-weight: 400;
				color: #333333;
			}
			
		}
		
		.company_info{
			margin-top: 0.4rem;
			display: flex;
			justify-content: center;
			.infocon{
				width: 10.73rem;
				height: 3.2rem;
				background: #FFFFFF;
				box-shadow: 1px 4px 18px 0px rgba(229, 1, 18, 0.13);
				border-radius: 0.05rem;
				display: flex;
				align-items: center;
				.imgcar{
					width: 3rem;
					display: flex;
					justify-content: center;
					img{
						width: 1.71rem;
						height: 1.48rem;	
					}
				}
				.line{
					width: 0.05rem;
					height: 2.22rem;
					background: #F4F4F4;
				}
				.concent{
					margin-left: 0.4rem;
					flex: 1;
					font-size: 0.16rem;
					font-weight: 400;
					color: #333333;
					.title{
						line-height: 0.5rem;
					}
				}
			}
			
		}	
			
		.p_donate{
			display: flex;
			justify-content: center;
			.p_con{
				width: 9rem;
				height: 4rem;
				.img_text{
					margin-left: 0.4rem;
					height: 1rem;
					display: flex;
					align-items: center;
					img{
						height: 0.25rpx;
						width: 0.25rem;
					}
					span{
						font-size: 0.16rem;
						font-weight: 400;
						color: #333333;
						margin-left: 0.2rem;
					}
				}
				
				.peopleprice{
					margin-left: 0.4rem;
					display: flex;
					align-items: center;					
					.people{
						span{
							font-size: 0.14rem;
							font-weight: 400;
							color: #333333;
							margin-right: 0.3rem;
						}
					}
					.price{
						margin-left: 0.6rem;
						span{
							font-size: 0.14rem;
							font-weight: 400;
							color: #333333;
							margin-right: 0.3rem;
						}
					}
					
				}
				
				.modecon{
					margin-left: 0.4rem;
					.list_a{
						display: flex;						
						.title{
							width: 1rem;
							font-size: 0.14rem;
							font-weight: 400;
							color: #333333;
						}
						.chioceinfo{
							flex: 1;
							.wx_zfb{
								display: flex;
								align-items: center;
								margin-bottom: 0.3rem;
								.yq{
									cursor: pointer;
									width: 0.16rem;
									height: 0.16rem;
									background: #E8E8E8;
									border: 1px solid #BFBFBF;
									border-radius: 50%;
								}
								.yq_cur{
									cursor: pointer;
									width: 0.16rem;
									height: 0.16rem;
									background: #E60012;
									border: 1px solid #E60012;
									border-radius: 50%;
								}
								.img{
									width:0.26rem;
									height:0.26rem;
									margin-left: 0.1rem;
									margin-right: 0.1rem;
								}
								.bg{
									width: 1.09rem;
									height: 0.23rem;
									line-height: 0.23rem;
									text-align: center;
									background: url(../../assets/otherImg/rectangle_img.png) no-repeat top center/ 100% 100%;
									font-size: 0.14rem;
									font-weight: 400;
									color: #666666;
									margin-right: 0.1rem;
								}
								.ms{
									font-size: 0.14rem;
									font-weight: 400;
									color: #999999;
								}
							}
						}
					}
				}
				
				.line{
					margin-top: 0.4rem;
					width: 9rem;
					height: 0.05rem;
					background: #F4F5F9	
				}
				
				.pricecon{
					display: flex;
					align-items: center;
					justify-content: space-between;
					height: 0.8rem;
					margin-left: 0.4rem;
					.l_c{
						display: flex;
						align-items: center;
						.a{
							font-size: 0.16rem;
							font-weight: 400;
							color: #333333;
						}
						.b{
							font-size: 0.18rem;
							font-weight: 400;
							color: #E61F26;
						}
						.c{
							font-size: 0.48rem;
							font-weight: 400;
							color: #E61F26;
							margin-left: 0.2rem;
						}
					}
					.r_c{
						display: flex;
						align-items: center;
						font-size: 0.14rem;
						font-weight: 400;
						color: #333333;
						margin-right: 0.4rem;
						cursor: pointer;
						.circle{
							cursor: pointer;
							width: 0.16rem;
							height: 0.16rem;
							background: #E8E8E8;
							border: 1px solid #BFBFBF;
							border-radius: 50%;
							margin-right: 0.1rem;
						}
						.circle_cur{
							cursor: pointer;
							width: 0.16rem;
							height: 0.16rem;
							background: #E50112;
							border: 1px solid #E60012;
							border-radius: 50%;
							margin-right: 0.1rem;
						}
					}					
				}
				
				.inform_con{
					margin-left: 0.4rem;
					.s_choice{
						display: flex;
						align-items: center;
						height: 0.8rem;
						.name{
							font-size: 0.14rem;
							font-weight: 400;
							color: #333333;
							width: 1.2rem;
						}
						.radiocon{
							display: flex;
							align-items: center;
							.circle{
								cursor: pointer;
								width: 0.16rem;
								height: 0.16rem;
								background: #E8E8E8;
								border: 1px solid #BFBFBF;
								border-radius: 50%;
							}
							.circle_cur{
								cursor: pointer;
								width: 0.16rem;
								height: 0.16rem;
								background: #E50112;
								border: 1px solid #E60012;
								border-radius: 50%;
							}
							.title{
								cursor: pointer;
								font-size: 0.14rem;
								font-weight: 400;
								color: #333333;
								margin-left: 0.2rem;
								margin-right: 0.2rem;
							}
						}
					}
					.l_a{
						height: 0.8rem;
						display: flex;
						align-items: center;
						font-size: 0.14rem; 
						font-weight: 400;
						color: #333333;
						.name{
							width: 1.2rem;
						}
					}
					.btncon{
						height: 1rem;
						display: flex;
						align-items: center;
						justify-content: center;
						.nextstep{
							cursor: pointer;
							width: 1.68rem;
							height: 0.36rem;
							line-height: 0.36rem;
							text-align: center;
							background: #E50112;
							border: 1px solid #E60012;
							font-size: 0.18rem;
							color: #FFFFFF;
						}
					}
					
					
				}
				
				
			}
			
		}
		
		
		
		
	}
		
		
	
	
}

</style>
